// Vue component for the directory structure rendering
<template>
    <span>
        <ul class="file-tree" v-if="root.isExpanded">
            <!-- Extend tree line -->
            <li class="tree-node tree-line"></li>

            <!-- Datasets -->
            <li class="tree-node" v-for="dataset in ordered(root.datasets)" :key="dataset.uuid">
                <dataset-tree :id="dataset.id" :name="dataset.name" :permission="dataset.permission" @selectCrumbs="selectCrumbs" />
            </li>

            <!-- Distributions -->
            <li class="tree-node distribution" v-for="dist in ordered(root.distributions)" :key="dist.uuid">
                <div class="text">
                    <i class="fa fa-file" />
                    <a @click="selectCrumbs([])">{{ dist.name }}</a>
                </div>
            </li>

            <!-- Groups -->
            <li class="tree-node" v-for="group in ordered(root.groups)" :key="group.uuid">
                <div class="pretext">
                    <span class="collapsible" @click="expand(group)"
                        v-if="group.datasets.length + group.distributions.length + group.groups.length > 0">
                        <i v-if="group.isExpanded" class="far fa-minus-square" />
                        <i v-else-if="!group.isExpanded" class="far fa-plus-square" />
                    </span>
                    <i v-else class="far fa-square" />
                </div>
                <div class="text">
                    <span class="folder">
                        <i v-if="group.groups.length == 0" class="fad fa-folder"
                            data-bs-toggle="tooltip" data-bs-placement="top" title="This group does not have subgroups" />
                        <i v-else class="fad fa-folders"
                            data-bs-toggle="tooltip" data-bs-placement="top" title="This group has subgroups" />
                    </span>
                    <a @click="clickGroup(group)"> {{ group.name }} </a>
                </div>

                <sub-tree :root="group" @selectCrumbs="selectCrumbs" />
            </li>
        </ul>
    </span>
</template>

<script>
export default {
    name: "SubTree",
    components: {
        DatasetTree: () => import("src/components/dataset/components/DatasetTree.vue")
    },
    props: {
        root: {
            type: Object,
            required: true,
        },
    },
    methods: {
        clickGroup: function(group) {
            this.expand(group)
            this.selectCrumbs([group])
        },
        selectCrumbs: function(crumbs) {
            // crumbs[0] is the selected group, and crumbs[i>0] give the breadcrumbs
            crumbs.push(this.root)
            this.$emit("selectCrumbs", crumbs)
        },
        ordered: function(list) {
            return list.toSorted((a, b) => a.order - b.order);
        },
        expand: function(group) {
            group.isExpanded = !group.isExpanded
        }
    }
}
</script>

<style scoped>
.file-tree {
    position: relative;
}

.tree-line {
    position: absolute;
    top: -1000px;
    height: 1000px;
}

.tree-line::before {
    display: none !important;
}

li::before {
    float: left;
}

.pretext {
    float: left;
    margin-right: 3.5px;
}

.pretext i {
    z-index: 1;
    position: relative;
    background-color: white;
    box-shadow: 0 -10px white;
}

.text {
    overflow: hidden;
}

.tree-node {
    overflow: hidden;
}

.tree-node.distribution::before {
    width: 2.1em;
}

a {
    cursor: pointer;
}
</style>
